'use strict';

DoohApps
.directive('include', ['$http', '$templateCache', '$compile', 'DoohConfig', function ($http, $templateCache, $compile, DoohConfig) {
    return function (scope, element, attrs) {
        var templatePath = attrs.include + '?v=' + DoohConfig.version;

        $http.get(templatePath, { cache: $templateCache }).then(function (response) {
            var contents = $('<div/>').html(response.data).contents();
            element.html(contents);
            $compile(contents)(scope);
        });
    };
}]);